import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import GenericBasicTableCellContent from './GenericBasicTableCellContent';

const GenericBasicTableView = props => {
  /* istanbul ignore next */
  const handleContentScroll = e => {
    const headerMenu = document.getElementById('header-right-column');
    const leftSideMenu = document.getElementById('left-menu-content');
    leftSideMenu.scrollTop = e.target.scrollTop;
    headerMenu.scrollLeft = e.target.scrollLeft;
  };

  const { tableData, tableHeader, isSegmentSummaryTable } = props;
  return (
    <div className="generic-bt" data-test="genericBasicTableView">
      <div className="generic-bt-header">
        <div className="generic-bt-header-left">
          <div className="generic-bt-header-left-empty" />
        </div>
        <div className="generic-bt-header-right" id="header-right-column">
          {tableHeader.map((item, columnIndex) => (
            <div key={uuid()} className="generic-bt-header-right-item">
              <Fragment>
                <button
                  type="button"
                  id={`${item.key}-header${columnIndex}`}
                  style={{ textAlign: 'left', width: '100%' }}
                  className="generic-bt-header-right-item-value"
                  title={item.text}
                >
                  {item.text}
                </button>
              </Fragment>
            </div>
          ))}
        </div>
      </div>
      <div id="main-content-grid" className="generic-bt-content">
        {tableData && (
          <GenericBasicTableCellContent
            key={uuid()}
            rowData={tableData.rowData}
            rowHeader={tableData.rowHeader}
            isSegmentSummaryTable={isSegmentSummaryTable}
            handleContentScroll={handleContentScroll}
          />
        )}
      </div>
    </div>
  );
};

GenericBasicTableView.propTypes = {
  tableData: PropTypes.shape({
    rowData: PropTypes.instanceOf(Array),
    rowHeader: PropTypes.instanceOf(Array),
  }),
  tableHeader: PropTypes.instanceOf(Array),
  isSegmentSummaryTable: PropTypes.bool,
};

export default GenericBasicTableView;
